import { getQueryObjectFromObject } from '@partoohub/utils';

import { useBusinessCityQueryParams } from './queryParams/useBusinessCityQueryParams';
import { useBusinessOrgIdQueryParams } from './queryParams/useBusinessOrgIdQueryParams';
import { useExcludedBusinessesQueryParams } from './queryParams/useExcludedBusinessesQueryParams';
import { useGroupsQueryParams } from './queryParams/useGroupsQueryParams';
import { useIncludedBusinessesQueryParams } from './queryParams/useIncludedBusinessesQueryParams';
import { useOrgsQueryParams } from './queryParams/useOrgsQueryParams';
import { useSearchQueryParams } from './queryParams/useSearchQueryParams';

export const useBusinessModalFiltersFromUrl = () => {
    const { includedBusinesses } = useIncludedBusinessesQueryParams();
    const { excludedBusinesses } = useExcludedBusinessesQueryParams();
    const { groups } = useGroupsQueryParams();
    const { org_id } = useOrgsQueryParams();
    const { business_org_id } = useBusinessOrgIdQueryParams();
    const { businessCity } = useBusinessCityQueryParams();
    const { search } = useSearchQueryParams();

    const business_org_idToNumber =
        org_id === '' && business_org_id === '' ? undefined : Number(org_id ?? business_org_id);

    return getQueryObjectFromObject(
        {
            business__in: includedBusinesses,
            business__notin: excludedBusinesses,
            groups,
            business_org_id: business_org_idToNumber,
            business_city: businessCity,
            business_query: search,
        },
        false,
    );
};
